<template>
<v-container fluid>
  <v-card>
    <v-card-text>       
      <v-form 
        ref="form" 
        v-model="valid" 
        :lazy-validation="lazy"
      >
        <v-row>
          <v-col cols="12" md="12">     
           <p class="font-weight-black">
          </p>
          </v-col>
      <v-col cols="12" md="12">
           <strong class="gray--text"> {{objEncuesta.nombreEncuesta}}</strong>
         
          </v-col>
          <v-col cols="12" md="3">        
      
        <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        disabled
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
          :value=getDateFormated(date)

            label="Fecha Inicio"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            outlined
            dense
            readonly
          ></v-text-field>
           
        </template>
        <v-date-picker
          v-model="date"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>    
    </v-col>
<v-col cols="12" md="3">
            <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        disabled
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value=getDateFormated(date2)
            label="Fecha Fin"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            outlined
            dense
            readonly
          ></v-text-field>
          
        </template>
        <v-date-picker
          v-model="date2"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>    
      </v-col>  
          <v-col cols="12" md="2">
            <v-text-field
              v-model="numeroParticipantesTolal"
              :loading="loading"
              label="Participantes"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>
        <v-col cols="12" md="2">
        <v-text-field
              v-model="objRolSave.correo"
              :loading="loading"
              label="Respuestas"
             readonly
              outlined
              dense
            ></v-text-field>
        </v-col>
         <v-col cols="12" md="2">
         <v-switch 
                      v-model="objEncuesta.envioCorreo"                       
                      class="mx-2" 
                      label="Envío de correo activo" 
                      required  
                      style="justify-content: center; display: grid;  margin-top:5px;"
                      hide-details
                      true
                      readonly
                    ></v-switch>
         </v-col>
        <v-col cols="12" md="10">
        </v-col> 
        </v-row>
 <v-container>
      <v-col cols="12" xs="12" sm="12" xl="12" md="12" lg="12">
        <v-row>
          <v-col v-for="(c, index) in objParticipantesEncuesta" :key="'itemObjPart_' + index" cols="12" xs="12" sm="12" xl="3" md="12" lg="3" :loading="loading">
            <v-card    
                  class="mx-auto card-ug"
                  shaped       
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      left>
                     view_list
                    </v-icon>
                    <span class="title font-weight-light azul-ug">
                       {{c.nombreGrupo}}
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>   
                      <v-col 
                        class="py-1" 
                        cols="12"
                      >
                        Total de Participantes
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                     {{c.numParticipantes}}     
                           </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-container>
      </v-form>   
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      
      <v-btn
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
  <v-snackbar
    key="snackbarFormEncuestaRol"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: "FormParticipantesEncuestas",
  props: {
    objEncuesta: {
      type: Object,
      required: true
    },
    objParticipantesEncuesta: {
      type: Array,
      required: true
    },
     flagReload: {
      type: Number,
      default: 0
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
    flagInit:{
      type: Number,
      default: 0
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: false,
      loadingSave: false,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      valid: false,
      lazy: false,
      objRolSave: {},
      banLimpiarDatos: 0,
      date:this.objEncuesta.fechaInicio == null ? null : this.objEncuesta.fechaInicio.substr(0,10),  
      date2:this.objEncuesta.fechaFin == null ? null : this.objEncuesta.fechaFin.substr(0,10),      
      menu2: false,
      menu1: false,
      numeroParticipantesTolal:null,
      loaginDatos:true,
      switch1: true,
        
    };
  },
  computed: {
  },
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
        this.inicializarFormulario();    
			},
     
    },
  },
  async mounted () {
    this.inicializarFormulario();
  },
  methods: {
    inicializarFormulario(){
      var self = this;
      self.loading = true;
      if(this.$refs.form != undefined){
        this.$refs.form.resetValidation();
      }
      self.loading = false;
      this.numeroParticipantesTolal=0;
      for (var i=0; i < this.objParticipantesEncuesta.length; i++) {
      this.numeroParticipantesTolal=this.numeroParticipantesTolal+this.objParticipantesEncuesta[i]['numParticipantes'];	
     }  
    },
     getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
    },     
    }
    };
</script>